module.exports = "/images/wind.svg?14a20ad383ee2ee17c506d6972866e0d";